import React, { Component } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import Modal from "@material-ui/core/Modal";
import DialogContent from "@material-ui/core/DialogContent";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Button from "components/CustomButtons/Button.js";
// services
import unityService from "services/unity.service";
import levelService from "services/level.service";
// management imports
import CadastrarUnidades from "./Cadastrar";
import DeletarUnidades from "./Deletar";
import CustomSelect from "components/CustomSelect/CustomSelect";
import EditarUnidades from "./Editar";

const styles = (theme) => ({
	cardCategoryWhite: {
		"&,& a,& a:hover,& a:focus": {
			color: "rgba(255,255,255,.62)",
			margin: "0",
			fontSize: "14px",
			marginTop: "0",
			marginBottom: "0",
		},
		"& a,& a:hover,& a:focus": {
			color: "#FFFFFF",
		},
	},
	cardTitleWhite: {
		color: "#FFFFFF",
		marginTop: "0px",
		minHeight: "auto",
		fontWeight: "300",
		fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
		marginBottom: "3px",
		textDecoration: "none",
		"& small": {
			color: "#777",
			fontSize: "65%",
			fontWeight: "400",
			lineHeight: "1",
		},
	},
});

class GerenciarUnidades extends Component {
	constructor(props) {
		super(props);
		this.state = {
			levels: [],
			units: [],
			show: "",
			editUid: "",
			selectedLevel: "",
		};
		this.handleChange = this.handleChange.bind(this);
		this.handleSearch();

		// this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		this.setState({
			selectedLevel: event.target.value,
		});

		unityService.getUnitsfromLevel(event.target.value).then((units) => {
			const tableUnits = [];
			units.forEach(async (unity) => {
				const level = this.state.levels.find(
					(level) => level.key === unity.level
				);
				tableUnits.push([
					unity.key,
					unity.order,
					unity.title,
					level.label,
					<Button
						color="primary"
						round
						onClick={(event) => {
							this.handleOpenEdit(unity.key);
						}}
						children="Editar"
					/>,
					<Button
						color="primary"
						round
						onClick={(event) => {
							this.handleOpenDelete(unity.key);
						}}
						children="Excluir"
					/>,
				]);
			});
			this.setState({ units: tableUnits });
		});
	}

	handleOpenCreate = () => {
		this.setState({ show: "create" });
	};

	handleOpenEdit = (uid) => {
		this.setState({ show: "edit", editUid: uid });
	};

	handleOpenDelete = (uid) => {
		this.setState({ show: "delete", editUid: uid });
	};

	async handleSearch() {
		const tableLevels = [];

		await levelService.listAllLevels().then((levels) => {
			levels.forEach((level) => {
				tableLevels.push({
					key: level.key,
					value: level.key,
					label: `${level.title} (${
						level.language === "english"
							? "Inglês"
							: level.language === "spanish"
							? "Espanhol"
							: level.language
					}) - ${level.key}`,
				});
			});

			this.setState({ levels: tableLevels });
		});

		unityService.listAllUnits().then((units) => {
			const tableUnits = [];
			units.forEach(async (unity) => {
				const level = this.state.levels.find(
					(level) => level.key === unity.level
				);
				tableUnits.push([
					unity.key,
					unity.order,
					unity.title,
					level.label,
					<Button
						color="primary"
						round
						onClick={(event) => {
							this.handleOpenEdit(unity.key);
						}}
						children="Editar"
					/>,
					<Button
						color="primary"
						round
						onClick={(event) => {
							this.handleOpenDelete(unity.key);
						}}
						children="Excluir"
					/>,
				]);
			});
			this.setState({ units: tableUnits });
		});
	}

	render() {
		const { classes } = this.props;
		return (
			<GridContainer>
				<GridItem xs={12} md={12}>
					<Button
						color="primary"
						type="submit"
						round
						onClick={this.handleOpenCreate}
						children="Cadastrar Unidade"
					/>
				</GridItem>
				<GridItem xs={12} md={8}>
					<CustomSelect
						labelText="Livro da Unidade"
						id="level"
						formControlProps={{
							fullWidth: true,
						}}
						inputProps={{
							type: "text",
							name: "selectedLevel",
							value: this.state.selectedLevel,
							onChange: this.handleChange,
						}}
						selectItems={this.state.levels}
					/>
				</GridItem>
				<GridItem xs={12} sm={12} md={12}>
					<Card>
						<CardHeader color="primary">
							<h4 className={classes.cardTitleWhite}>
								Lista de Unidades
							</h4>
							<p className={classes.cardCategoryWhite}>
								Lista para visualização e gerenciamento das
								Unidades
							</p>
							<p>
								Obs: Unidades são ordenadas da menor para a
								maior ordem
							</p>
						</CardHeader>
						<CardBody>
							<Table
								tableHeaderColor="primary"
								tableHead={[
									"ID da Unidade",
									"Ordem da Unidade",
									"Título da Unidade",
									"Livro",
									"Editar",
									"Excluir",
								]}
								tableData={this.state.units}
							/>
						</CardBody>
					</Card>
				</GridItem>
				<Modal
					open={this.state.show === "create"}
					onClose={() => {
						this.setState({ show: "" });
						this.handleSearch();
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<DialogContent>
						<CadastrarUnidades
							onClose={() => {
								this.setState({ show: "" });
								this.handleSearch();
							}}
						/>
					</DialogContent>
				</Modal>
				<Modal
					open={this.state.show === "edit"}
					onClose={() => {
						this.setState({ show: "" });
						this.handleSearch();
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<DialogContent>
						<EditarUnidades
							uid={this.state.editUid}
							onClose={() => {
								this.setState({ show: "" });
								this.handleSearch();
							}}
						/>
					</DialogContent>
				</Modal>
				<Modal
					open={this.state.show === "delete"}
					onClose={() => {
						this.setState({ show: "" });
						this.handleSearch();
					}}
					aria-labelledby="simple-modal-title"
					aria-describedby="simple-modal-description"
				>
					<DialogContent>
						<DeletarUnidades
							uid={this.state.editUid}
							onClose={() => {
								this.setState({ show: "" });
								this.handleSearch();
							}}
						/>
					</DialogContent>
				</Modal>
			</GridContainer>
		);
	}
}

GerenciarUnidades.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(GerenciarUnidades);
